import React, { useState, useEffect, useContext } from "react";
import TvArtistSlider from "./TvArtistSlider";
import TvPosterSlider from "./TvPosterSlider";
import axios from "axios";
import { Rings } from "react-loader-spinner";

import "./Tv.scss";
import { MovieIndexContext } from "../../context/MovieIndexContext";

const Tv = () => {
  const [content, setContent] = useState([]);
  const [cast, setCast] = useState([]);
  const [movieId, setMovieId] = useState(0);
  const { loading, setLoading } = useContext(MovieIndexContext);

  const changeEventHandler = (selectedMovieId) => {
    setMovieId(selectedMovieId.activeIndex);

    console.log(selectedMovieId.activeIndex);
  };
  // console.log("movieId", movieId);

  const fetchedMoviesData = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/trending/tv/week?api_key=${process.env.REACT_APP_API_KEY}`
    );
    // console.log("MovieList", data.results);
    setContent(data.results);
    setLoading(true);
  };

  const fetchedMoviesArtists = async () => {
    const { data } = await axios.get(
      `https://api.themoviedb.org/3/tv/${content[movieId].id}/credits?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`
    );
    setCast(data?.cast);
    setLoading(true);
  };

  useEffect(() => {
    // console.log("Ddd");
    fetchedMoviesData();
  }, []);
  useEffect(() => {
    if (content.length > 0 && movieId >= 0) fetchedMoviesArtists();
    // eslint-disable-next-line
  }, [movieId, content]);
  // console.log("castParsent", cast);
  // console.log("newdata", content);

  return (
    <div className="tv-tab">
      {loading ? (
        <TvPosterSlider content={content} movieId={changeEventHandler} />
      ) : (
        <Rings width={1000} height={200} color="#a83119" />
      )}

      <div className="tv-tab__artist-section">
        <div className="tv-tab__best-artists-title">Best Artists</div>
        {loading ? (
          <TvArtistSlider cast={cast} />
        ) : (
          <Rings width={1000} height={200} color="#a83119" />
        )}
      </div>
    </div>
  );
};

export default Tv;
